import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';
import { Modal } from 'bootstrap';

class CtrMsgMensagens extends (Component){

    constructor(props) {        
        super(props);
        this.state = {
            show: false,
            msgId: null,
            msgRead: null,
            msgAnswrd: null,
            msgDate: null,
            reqType: null,
            reqId: null,
            reqData: null,
            readBtnLbl: null,
            msngStat: null,
        };

        this.msgTxt = React.createRef();

    }


    showCtrMsgMensagen = (msgid, msgread, msganswrd, msgdt,rqtyp, rqid) => {
        this.setState({msgId: msgid});
        this.setState({msgRead: msgread});
        this.setState({msgAnswrd: msganswrd});
        this.setState({msgDate: msgdt});
        this.setState({reqType: rqtyp});
        this.setState({reqId: rqid});
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), msgRcptId: msgid, reqType:rqtyp, reqId: rqid}),
            
        };

        fetch(apisettigs.endpoints.ctrlMsgsShowMessage, requestOptions).then(response => response.json())
        .then(data => {
            //console.log(data);
            this.setState({reqData: data});    
            
            if (msgread === 'Y'){
                this.setState({readBtnLbl: 'Não Lido'});
            }
            else{
                this.setState({readBtnLbl: 'Lido'});
            }

            if (msganswrd === 'Y') {
                this.setState({msngStat: 'msgAns'});
            }
            else if (msgread === 'N'){
                this.setState({msngStat: 'msgNew'});
            }
            else{
                this.setState({msngStat: 'd-none'});
            }

            this.setState({show: true});    
        });
        

    }

    hideCtrMsgMensagen = () => {
        this.setState({show:false});
        this.setState({msgId: null});
        this.setState({msgRead: null});
        this.setState({msgAnswrd: null});
        this.setState({msgDate: null});
        this.setState({reqType: null});
        this.setState({reqId: null});
        this.setState({reqData: null});
        this.setState({readBtnLbl: null});
        this.setState({msngStat: null});
    }
 
    voltar = () => { 
        this.hideCtrMsgMensagen();
        this.props.showCentralMsg();
    }


    marcarMsg = (origmsgid) => {

        if (this.state.readBtnLbl === 'Não Lido'){
            //marcar como não lido
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), origMsgId: origmsgid, mark: 'N'}),
                
            };

            fetch(apisettigs.endpoints.ctrlMsgsMarkMsg, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);
                //nao estou confirmando se atualizaou
                //change css
                this.setState({readBtnLbl:'Lido'});
                this.setState({msngStat:'msgNew'});
            });
        }
        else{   //marcar como lido
            //post para marcar como lida

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), origMsgId: origmsgid, mark: 'Y'}),
            };

            fetch(apisettigs.endpoints.ctrlMsgsMarkMsg, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);
                //nao estou confirmando se atualizou
                //change css
                this.setState({readBtnLbl:'Não Lido'});
                this.setState({msngStat:'d-none'});
            });
        }
    }



    addResp = () => {
        let btnAdd = document.getElementById('btnrespmg');
    
        btnAdd.disabled = true;

        let modalCnfrmMsgElement = document.getElementById('ModalCnfrmSndMsg');

        modalCnfrmMsgElement.addEventListener('hidden.bs.modal', () =>{
            this.voltar();
        });

        const modalCfrmMsgSnd = new Modal(modalCnfrmMsgElement);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ 
                userid: window.sessionStorage.getItem("userId"),
                reqId: this.state.reqId,
                reqType: this.state.reqType,
                txtmsg: this.msgTxt.current.textContent.trim(),
                origMsgId: this.state.reqData.origMsgId,
                thisMsgrcptId:this.state.msgId,
                senderId: this.state.reqData.senderId,               
            })
        };

        if (this.msgTxt.current.innerHTML.trim().length <= 1){
            const modalCnfrmMsgWng =  Modal.getOrCreateInstance(document.getElementById('ModalCnfrmSndMsgWng'));
            modalCnfrmMsgWng.show();
            btnAdd.disabled = false;
        }
        else{
            fetch(apisettigs.endpoints.ctrlMsgsAddResp, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.addResponse === 'ok'){
                    modalCfrmMsgSnd.show();
                }
            });
        }

    }


    limitChars = (e) => {
        if(e.target.innerHTML.length > 500 ){
            console.log('limite atingido');

            if (e.keyCode === 8 || e.keyCode === 46 ){
            }
            else{
                e.preventDefault();
            }
        }
    }


    render(){
        if (this.state.show === true){
            return(
                <>
                    <div className='container position-relative mt-4 msgCtitleCnt '>
    
                        <div className={'col- position-absolute'}  style={{'width':'10%', 'top':'0', 'right':'0'}}>
                                <div className={this.state.msngStat}>
                                    &nbsp;
                                </div>
                        </div>

                        <div className='container' >
                            <span className='colT0'> {this.state.reqType} ID: {this.state.reqId}</span>   
                            <div className='container mt-1' style={{'paddingBottom': '.2rem'}}>
                                <div className='row'>
                                    <div className='col-  obstxt3  colT1 '>
                                        <div>C.C. Aprovador:</div>
                                        <div>Valor Total:</div>
                                        <div>Observação:</div>
                                    </div>
                                    <div className='col obstxt3' >
                                        <div>{this.state.reqData.reqCcAprov}</div>
                                        <div>{this.state.reqData.reqVal}</div>
                                        <div style={{'lineHeight': '.9rem'}}>{this.state.reqData.reqObs}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container mt-4'>
                        <div className='row  d-flex'>
                            <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                Data:
                            </div>
                            <div className='col- align-self-center colTextMsg ' style={{maxWidth:'54%'}}>
                            {this.state.msgDate}
                            </div>
                        </div>
                        
                        <div className='row  d-flex'>
                            <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                De:
                            </div>
                            <div className='col- align-self-center colTextMsg  ' style={{maxWidth:'54%'}}>
                                {this.state.reqData.senderName}    
                            </div>
                        </div>
                        
                        <div className='row '>
                            <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                Para:
                            </div>
                            <div className='col- align-self-center colTextMsg ' style={{maxWidth:'75%'}}>
                            {this.state.reqData.principalName}  
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                Cópia:
                            </div>
                            <div className='col- align-self-center colTextMsg ' style={{maxWidth:'75%'}}>
                            {this.state.reqData.copies} 
                            </div>
                        </div>
                    </div>

                    <div className='container mt-4 MsgSbT1'>
                        Mensagem:
                    </div>

                    <div className='container mt-2'>
                        <div className='container Msgmsg2 '>
                            {this.state.reqData.msgText}    
                        </div>
                    </div>

                    <div className='container mt-2 MsgSbT1'>
                        Resposta:
                    </div>
                    <div className='container mt-2'> 
                        <div className='form-control Msgmsg3' contentEditable={this.state.msgAnswrd === 'Y' ? false : true} onKeyDown={this.limitChars} 
                            onKeyUp={this.limitChars} style={{'width':'100%', 'backgroundColor': this.state.msgAnswrd === 'Y' ? '#F9FAFC':'#fff' }} ref={this.msgTxt}>
                            {this.state.reqData.answerTxt} 
                        </div>
                    </div>

                    <div className='container mb-1'>
                        <div className="d-flex justify-content-between" style={{'marginTop':'2rem', 'paddingLeft':'1.5rem', 'paddingRight':'1.5rem'}}>
                            <button type="button"  disabled={this.state.msgAnswrd === 'Y' ? true : false } onClick={ ()=>{this.marcarMsg(this.state.reqData.origMsgId);}} className="btn btn-outline-info bckbt">{this.state.readBtnLbl}</button>
                            <button type="button" id="btnrespmg" disabled={this.state.msgAnswrd === 'Y' ? true : false } onClick={ () => {this.addResp()}} className="btn btn-outline-success bckbt">Responder</button>
                            <button type="button" className="btn btn-outline-primary bckbt" onClick={this.voltar}>Voltar</button>
                        </div>
                    </div>
                    &nbsp;
                    
                    <div className="modal fade" id="ModalCnfrmSndMsg" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered justify-content-center">
                            <div className="modal-content modalConfirmCnt">
                                <div className="modalConfirmHeader">
                                    Aviso
                                </div>
                                <div className="mt-2">
                                    <div className="modalConfirmT2" >
                                        Mensagem Enviada.
                                    </div>                    
                                   
                                    <div className="mt-4 mb-4 d-flex justify-content-center ">
                                        <div className='btnGrey' style={{marginLeft:'0'}} data-bs-dismiss="modal"><i className="fas fa-long-arrow-alt-left"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="ModalCnfrmSndMsgWng" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered justify-content-center">
                            <div className="modal-content modalConfirmCnt">
                                <div className="modalConfirmHeader">
                                    Aviso
                                </div>
                                <div className="mt-2">
                                    <div className="modalConfirmT2" >
                                       Verifique o conteudo da mensagem.
                                    </div>                    
                                   
                                    <div className="mt-4 mb-4 d-flex justify-content-center ">
                                        <div className='btnGrey' style={{marginLeft:'0'}} data-bs-dismiss="modal"><i className="fas fa-long-arrow-alt-left"></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else{
            return null;
        }
    }
}

export default CtrMsgMensagens;